/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import * as React from 'react'
import { SwitcherContainer, Switcher, SwitcherDot } from './styles'
type SwitcherContentProps = {
  checked?: boolean
  disabled?: boolean
  label?: string
}
export const SwitcherContent: React.SFC<SwitcherContentProps> = ({
  label,
  checked,
  disabled,
  // @ts-ignore
  ...rest
}) => (
  // @ts-ignore
  <SwitcherContainer disabled={disabled}>
    {label}
    <Switcher isChecked={checked} disabled={disabled}>
      <SwitcherDot isChecked={checked} />
    </Switcher>
  </SwitcherContainer>
)
